<app-shared-workshop-card
  [title]="request.workshop.title"
  [coverImage]="request.workshop.coverImage"
  [rows]="cardRows"
  [actions]="cardActions"
></app-shared-workshop-card>
